import axiosConfig from '../modules/axiosConfig'
import utils from '../modules/utils'

const HTTP = axiosConfig.HTTP

const state = {
  code: '',
  loading: false,
  error: '',
  errorDescription: ''
}

// getters
const getters = {
  getListHoldingData: state => state.code
}

// actions
const actions = {

  selectHolding: ({ commit }, holding) => {
    commit('SET_UNIQUE_HOLDING', holding)
  },

  async listHolding ({ commit, rootState }, data) {
    const config = rootState.appConfig.configFile

    try {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const storageAppToken = sessionStorage.getItem('token')
      const hashToken = utils.SHA256(storageAppData.entidad + storageAppToken + storageAppData.canal)
      let body = {}
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: false,
            businesstimeout: '',
            canal: storageAppData.canal,
            claveFin: '',
            claveInicio: '',
            entidad: storageAppData.entidad,
            idioma: 'ES',
            indMasDatos: '',
            oficina: '',
            pantPagina: 0,
            retroceder: false,
            mainUser: storageAppData.mainUser,
            securityToken: hashToken
          }
        }
      })
      commit('LISTHOLDING_REQUEST_STARTED', true)
      const response = await HTTP.post(config.endpoints.listHolding, body)

      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      if (response.status === 200) {
        switch (response.data.runServiceResponse.return.retorno) {
          case '000':
            commit('LISTHOLDING_REQUEST_SUCCEED', response.data.runServiceResponse.return)
            if (Array.isArray(response.data.runServiceResponse.return.registros)) return response.data.runServiceResponse.return.registros
            else return [response.data.runServiceResponse.return.registros]

          case 210:
            return false

          default:
            commit('HANDLE_ERROR', response.data.runServiceResponse.return.retorno, { root: true })
            return false
        }
      }
      commit('LISTHOLDING_REQUEST_FINISHED', false)
      return response
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },
  loader ({ commit }, actions) {
    commit('SET_LOADER', actions)
  }
}

// mutations
const mutations = {
  'SET_LOADER' (state, actions) {
    state.loading = actions.loader === true
    state.isPasswordText = actions.password === true
  },
  'LISTHOLDING_REQUEST_STARTED' (state, payload) {
    state.loading = payload
  },
  'LISTHOLDING_REQUEST_FINISHED' (state, payload) {
    state.loading = payload
  },
  'LISTHOLDING_REQUEST_SUCCEED' (state, payload) {
    const datos = payload
    state.error = false
    state.errorDescription = ''
    state.code = datos.totalRegistros > 1 ? datos.registros : Array(datos.registros)
  },
  'LISTHOLDING_REQUEST_FAILED' (state, payload) {
    if (payload.retorno === 200) {
      state.errorDescription = 'Error ejecución de servicio'
    } else if (payload.retorno === 220) {
      state.errorDescription = 'Error técnico'
    } else if (payload.retorno === '039') {
      state.errorDescription = 'Sesión expirada'
    } else if (payload.retorno === 210) {
      state.errorDescription = 'No se encontraron datos para los criterios de selección'
    }
    state.error = true
    state.code = ''
  },
  'SET_UNIQUE_HOLDING' (state, payload) {
    const datos = payload
    state.error = false
    state.errorDescription = ''
    state.code = Array(datos)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
